import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { InputTextareaModule } from "primeng/inputtextarea";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: "app-extensible-textarea",
  standalone: true,
  imports: [InputTextareaModule, FormsModule, ButtonModule, DialogModule, TooltipModule, CommonModule],
  templateUrl: "./extensible-textarea.component.html",
  styleUrl: "./extensible-textarea.component.scss",
})
export class ExtensibleTextareaComponent {
  @Output() readonly textChange = new EventEmitter<string>();
  @Input({ required: true }) text!: string;
  @Input({ required: false }) rows = 10;
  @Input({ required: false }) invalid = false;

  displayDialog = false;

  showDialog(): void {
    this.displayDialog = true;
  }
}
